import brokerService from "../services/broker.service";

const brokers = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, formData) {
            return brokerService.create(formData);
        },
        addNote(_, params) {
            return brokerService.addNote(params.brokerId, params.text);
        },
        //READ
        get(_, params) {
            return brokerService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return brokerService.getlist();
        },
        comissionreport(_, params) {
            return brokerService.comissionReport(params.fromDate, params.toDate);
        },
        //UPDATE
        update(_, params) {
            return brokerService.update(params.id, params.formData);
        },
        //DELETE
        delete(_, id) {
            return brokerService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default brokers;
